import React from 'react';


const End = () => {
  return (
  <footer>
      <p>
          @ Hacker News Clone | | All rights are reserved....
      </p>
      <ul>
      <li>
                <a
                  id="icon"
                  href="https://github.com/Karishma1208/"
                  ><i class="fab fa-github fa-2x"></i
                ></a>
              </li>
              
              <li>
                <a
                  id="icon"
                  href="https://www.linkedin.com/in/karishma-bhusari-055347152/"
                  ><i class="fab fa-linkedin-in fa-2x"></i
                ></a>
              </li>

                <li>
                <a id="icon" href="mailto:karishmabhusari@gmail.com"
                  ><i class="fab fa-google fa-2x"></i
                ></a>
              </li>

        </ul>
  </footer>
  );
};

export default End;